import { createApp } from 'vue'

//引入ElementPlus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import i18n from './locales'
// 统一导入el-icon图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
//引入ElementPlus 结束

import 'xe-utils'

//多标签bus通信
import $bus from '@/utils/bus'

//导入自定义css
import './assets/css/common.scss'
//导入响应式样式
import './assets/css/responsive.scss'
//elementplus暗黑主题从（element-plus/theme-chalk/dark/css-vars.css）拷贝
import './assets/css/elementplus-theme-dark-css-vars.css'
//解决elementplus组件console的scroll、wheel等事件的警告
import '@/utils/browser_console'

import App from './App.vue'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'

import router from './router'

const app = createApp(App)

app.config.globalProperties.axios = axios

// vue3.x的全局实例，要挂载在config.globalProperties上
app.config.globalProperties.$Bus = $bus

// 引入全局api
import * as myAPI from './api/api'
app.config.globalProperties.$Api = myAPI

//引入状态管理
import {isShowBtn,hasPermission,formatUnitSize} from '@/utils/util'
app.config.globalProperties.isShowBtn = isShowBtn
app.config.globalProperties.hasPermission = hasPermission
app.config.globalProperties.formatUnitSize = formatUnitSize
// 过滤器
import * as custom from './utils/util'
Object.keys(custom).forEach(key => {
  app.component(key, custom[key])
})

// //进入自定义指令
import directivePlugin from '@/utils/directive.js'

// 注册全局elementplus icon组件
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}


import registerSvgIcon from "@/icons"
registerSvgIcon(app)

// import draggable from '@/components/vuedraggable/dist/vuedraggable.umd.js'
// app.component('draggable', draggable)

import lyContainerWidgets from '@/components/lyform-builder/lyform-design/lycontainers-widget/index'
import lyFieldWidget from '@/components/lyform-builder/lyform-design/lyfield-widget/index'
import lySettingPannel from '@/components/lyform-builder/lysetting-pannel/lywidget-setting/index'

//注册自定义组件
import lyComponents from '@/components/index' //加载公共组件

app.use(ElementPlus)
app.use(i18n)
app.use(lyContainerWidgets)
app.use(lyFieldWidget)
app.use(lySettingPannel)
app.use(lyComponents)
app.use(store)
app.use(router)
app.use(VueAxios,axios)
app.use(directivePlugin)

// 忽略 ResizeObserver 错误
const ignoreResizeObserverError = () => {
  const originalConsoleError = console.error
  console.error = (...args) => {
    if (
      args.length > 0 &&
      typeof args[0] === 'string' &&
      args[0].includes('ResizeObserver')
    ) {
      return
    }
    originalConsoleError.apply(console, args)
  }

  window.addEventListener('error', (event) => {
    if (event.message && event.message.includes('ResizeObserver')) {
      event.stopImmediatePropagation()
      event.stopPropagation()
      event.preventDefault()
      return false
    }
  }, true)
}

// 调用错误处理函数
ignoreResizeObserverError()

app.mount('#app')


